import { render, staticRenderFns } from "./InputAdicionarProduto.vue?vue&type=template&id=b6e9ea38&scoped=true&"
import script from "./InputAdicionarProduto.vue?vue&type=script&lang=js&"
export * from "./InputAdicionarProduto.vue?vue&type=script&lang=js&"
import style0 from "./InputAdicionarProduto.vue?vue&type=style&index=0&id=b6e9ea38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e9ea38",
  null
  
)

export default component.exports